module.exports = __webpack_public_path__ + "img/new-image-bg.06ff8014.png";